import { computable, iterable, mix, observable } from "@chorda/core";
export const Breadcrumb = (props) => {
    return mix({
        classes: {
            'is-active': props.active
        },
        templates: {
            content: {
                text: props.text,
                dom: {
                    href: props.link
                },
                reactions: {
                    text: v => ({ text: v }),
                }
            }
        },
        reactions: {
            active: v => ({ classes: { 'is-active': v } }),
        }
    });
};
export const Breadcrumbs = (props) => {
    return mix({
        tag: 'nav',
        css: 'breadcrumb',
        templates: {
            content: {
                tag: 'ul',
                defaultItem: {
                    tag: 'li',
                    templates: {
                        content: {
                            tag: 'a',
                            reactions: {
                            // data: (v: any) => ({
                            //     text: v && v.text,
                            //     dom: {
                            //         href: v && v.link
                            //     }
                            // })
                            }
                        }
                    },
                    //                     reactions: {
                    //                         item: (v, next, {isLast}) => {
                    // //                            if (v) {
                    //                                 ({
                    //                                     classes: {'is-active': isLast}
                    //                                 })
                    // //                            }
                    //                         }
                    //                     },
                },
                reactions: {
                    items: v => ({ items: v }),
                    __it: v => ({ items: v }),
                },
                injections: {
                    __it: $ => $.items2 && iterable($.items3, null)
                }
            }
        }
    }, {
        defaults: {
            items: () => props.items && observable(props.items),
            items2: () => null,
        },
        injections: {
            items2: props.items$,
            items3: $ => computable(() => {
                return $.items2.map((b, i) => {
                    return Object.assign(Object.assign({}, b), { active: $.items2.length - 1 == i });
                });
            })
        },
        templates: {
            content: {
                defaultItem: props.itemAs
            }
        }
    });
};
